import { Checkbox } from "@dash/form";
import { useToast } from "@dash/toast";
import Decimal from "decimal.js";
import { useQueryClient } from "react-query";

import { OrderDraftChargeDto } from "@megaron/crm-contracts";
import { useClientManager } from "@megaron/react-clients";
import { Uuid } from "@megaron/uuid";

const LOGISTICS_CHARGE: OrderDraftChargeDto = {
  itemNumber: "TRANSPORT",
  quantity: new Decimal(1),
  price: new Decimal(100),
};

type Props = {
  charges: OrderDraftChargeDto[];
  isDisabled?: boolean;
  orderUuid?: Uuid;
  queryKey?: string | string[];
};

export const ChargesSection: React.FC<Props> = ({ charges, isDisabled, orderUuid, queryKey }) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const setChargesMutation = useClientManager("crm").setDraftCharges().useMutation();

  const isChecked = charges.some((c) => c.itemNumber === LOGISTICS_CHARGE.itemNumber);

  const handleChange = (checked: boolean) => {
    if (!orderUuid) return;

    const updatedCharges = checked
      ? [...charges.filter((c) => c.itemNumber !== LOGISTICS_CHARGE.itemNumber), LOGISTICS_CHARGE]
      : charges.filter((c) => c.itemNumber !== LOGISTICS_CHARGE.itemNumber);

    setChargesMutation.mutate(
      { uuid: orderUuid, charges: updatedCharges },
      {
        onSuccess: () => queryClient.invalidateQueries(queryKey),
        onError: () => toast.error("Wystąpił błąd podczas aktualizacji dopłat"),
      },
    );
  };

  return (
    <Checkbox
      value={isChecked}
      onChange={handleChange}
      label="Dopłata logistyczna (100 PLN)"
      isDisabled={isDisabled || setChargesMutation.isLoading || !orderUuid}
    />
  );
};
